import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { cardHoverAnimation, myPalette } from '~/shared/ui/theme'

export const Wrapper = styled(Link)`
  box-shadow: 0 0 5px ${myPalette.dark.shadowLight};
  background-color: ${myPalette.white.main};
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  text-decoration: none;
  padding: 16px;
  cursor: pointer;
  ${cardHoverAnimation}
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`

export const Title = styled.span`
  font-size: 14px;
  line-height: 18px;
  color: ${myPalette.dark.main};
`

export const Img = styled.img`
  width: 36px;
  height: 36px;
  margin-right: 12px;
`

export const NavText = styled.div`
  font-size: 18px;
  color: ${myPalette.midnightBlue.main};
  white-space: nowrap;
  min-width: 100px;
`
